import { atom, getDefaultStore } from 'jotai';
import { TableDataState, TableFilters, TableState, TblStats, TblView } from '../../../core/table/table.types';
import { tableDataVM, tableStateVM, tableStatsVM, tableViewVM } from '../../../core/table/table_view_models';
import { PageState } from '../../../core/page/page.types';
import tableViewRepo from '../../../core/repo/viewStateRepo';
import { PayorDataItem, PayorImportState } from './payor_list_types';
import { PAYOR_LIST_STORAGE_KEY } from '../payor_const';
import { pageStateVM } from '../../../core/page/page_view_models';
import { payorImportStateVM } from './payor_list_view_models';

export const pageStateAtom = atom<PageState>(pageStateVM());
export const tableStateAtom = atom<TableState>(tableStateVM());
export const tableViewAtom = atom<TblView>(tableViewVM());
export const tableFiltersAtom = atom<TableFilters>({});
export const tableStatsAtom = atom<TblStats>(tableStatsVM());
export const payorDataAtom = atom<TableDataState<PayorDataItem>>(tableDataVM<PayorDataItem>());
export const payorImportStateAtom = atom<PayorImportState>(payorImportStateVM());

export function setAtomPayorListTableViewState(): void {
    // on Table exit save viewstate
    // note this can read the current Jotai values without subscribing (Jotai accessors)
    const defaultStore = getDefaultStore();
    const flt = defaultStore.get<TableFilters>(tableFiltersAtom);
    const stats = defaultStore.get<TblStats>(tableStatsAtom);
    const view = defaultStore.get<TblView>(tableViewAtom);
    tableViewRepo.setTable(PAYOR_LIST_STORAGE_KEY, flt, stats.paging, view.sort);
}
